module.exports = __webpack_public_path__ + "img/144ne.a3d5e171.svg";